(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kwelafe-library"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('kwelafe-library')) return;
  // Native scroll containers remain usable before enhancement and without JavaScript.
  customElements.define('kwelafe-library', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.resize?.disconnect(); }
    init() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.abort = new AbortController();
      this.loading = false;
      const { signal } = this.abort;
      this.rows = [...this.querySelectorAll('[data-universe]')];
      this.resize = new ResizeObserver(() => this.update());
      for (const row of this.rows) {
        const track = row.querySelector('.kw-library__track');
        this.resize.observe(track);
        track.addEventListener('scroll', () => this.updateRow(row), { passive: true, signal });
        for (const button of row.querySelectorAll('[data-direction]')) {
          button.addEventListener('click', () => this.move(track, Number(button.dataset.direction) * track.clientWidth * .9), { signal });
        }
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          const rtl = getComputedStyle(track).direction === 'rtl';
          const moves = { ArrowLeft: -track.clientWidth * .9, ArrowRight: track.clientWidth * .9, Home: (rtl ? 1 : -1) * track.scrollWidth, End: (rtl ? -1 : 1) * track.scrollWidth };
          if (!(event.key in moves)) return;
          event.preventDefault();
          this.move(track, moves[event.key], false);
        }, { signal });
      }
      this.querySelector('.kw-library__retry').addEventListener('click', () => this.loadRemaining(), { signal });
      this.update();
      this.loadRemaining();
    }
    move(track, left, logical = true) {
      if (logical && getComputedStyle(track).direction === 'rtl') left *= -1;
      track.scrollBy({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    updateRow(row) {
      const track = row.querySelector('.kw-library__track');
      const count = track.children.length;
      row.hidden = count === 0;
      const max = track.scrollWidth - track.clientWidth;
      const buttons = row.querySelectorAll('[data-direction]');
      row.querySelector('.kw-library__controls').hidden = max <= 2;
      buttons[0].disabled = Math.abs(track.scrollLeft) <= 2;
      buttons[1].disabled = Math.abs(track.scrollLeft) >= max - 2;
      if (count) this.querySelector('[data-empty-for="' + row.dataset.universe + '"]')?.remove();
    }
    update() { this.rows.forEach(row => this.updateRow(row)); }
    async loadRemaining() {
      if (this.loading) return;
      this.loading = true;
      const controller = this.abort;
      const retry = this.querySelector('.kw-library__retry');
      retry.hidden = true;
      try {
        while (this.dataset.next && this.isConnected && this.rows.some(row => row.querySelector('.kw-library__track').children.length < Number(row.dataset.limit))) {
          const url = new URL(this.dataset.next, location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Catalog request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('kwelafe-library');
          if (!next) throw new Error('Catalog section missing');
          if (controller.signal.aborted) return;
          for (const row of this.rows) {
            const track = row.querySelector('.kw-library__track');
            const ids = new Set([...track.children].map(card => card.dataset.productId));
            for (const card of next.querySelectorAll('[data-universe="' + row.dataset.universe + '"] .kw-library__card')) {
              if (track.children.length < Number(row.dataset.limit) && !ids.has(card.dataset.productId)) {
                ids.add(card.dataset.productId);
                track.append(document.importNode(card, true));
              }
            }
          }
          if (next.dataset.next === this.dataset.next) throw new Error('Catalog pagination did not advance');
          this.dataset.next = next.dataset.next || '';
          this.update();
        }
      } catch (error) {
        if (error.name !== 'AbortError' && controller === this.abort) retry.hidden = false;
      } finally {
        if (controller === this.abort) this.loading = false;
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
